import { css } from "@emotion/react";
import { breakpoints } from "../../../constants/mediaqueries";

export const bottomBarStyles = css`
    z-index: 1000;
    position: fixed;
    bottom: 1rem;
    left: 50%;
    max-width: 2800px;
    width: 100%;
    padding-inline: 1rem;
    transform: translateX(-50%);

    @media (min-width: ${breakpoints[1]}px) {
        bottom: 0; 
    }
`;

export const launcherStyles = css`
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 2.5rem;

    @media (min-width: ${breakpoints[1]}px) {
        gap: 2rem;
    }
`;
